"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";

import type ResourceAssetTemplate from "@/templates/ResourceAsset";
import {
  ReadableCopy,
  ReadableResourceAsset,
  readableFallback,
} from "@/components/readable";

const ResourceAsset = dynamic(() => import("@/templates/ResourceAsset"), {
  ssr: false,
  loading: readableFallback("min-h-[600px]"),
});

export default function ClientOnlyResourceAsset(
  props: ComponentProps<typeof ResourceAssetTemplate>,
) {
  return (
    <ReadableCopy
      copy={
        <ReadableResourceAsset
          page={props.page}
          type={props.type}
          locale={props.locale ?? "en"}
        />
      }
    >
      <ResourceAsset {...props} />
    </ReadableCopy>
  );
}
